<div [formGroup]="parentForm">
  <div [formGroupName]="authControlKey">
    <div fxLayout="row wrap" fxLayoutGap="20px grid">
      <div fxFlex="100">
        <mat-card class="u-margin-bottom-15">
          <mat-card-header>
            <mat-card-title
              >{{
              "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.authentication_details"
              | translate }}</mat-card-title
            >
          </mat-card-header>
          <mat-card-content>
            <div fxFlex="100">
              <div fxLayout="row wrap" fxLayoutGap="20px grid">
                <div fxFlex="50">
                  <mat-form-field class="mat-block">
                    <input
                      formControlName="ebasketInventorySignatureMethod"
                      id="ebasketInventorySignatureMethod"
                      matInput
                      [placeholder]="
                    'organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.signature_method' |
                    translate"
                      readonly
                    />
                  </mat-form-field>
                </div>
                <div fxFlex="50">
                  <mat-form-field class="mat-block">
                    <input
                      [required]="isRequired('ebasketInventoryConsumerKey')"
                      formControlName="ebasketInventoryConsumerKey"
                      id="ebasketCustomerKey"
                      matInput
                      [placeholder]="
                    'organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.consumer_key' |
                    translate"
                    />
                  </mat-form-field>
                </div>
              </div>
              <div fxLayout="row wrap" fxLayoutGap="20px grid">
                <div fxFlex="50">
                  <mat-form-field class="mat-block">
                    <input
                      [required]="isRequired('ebasketInventoryConsumerSecret')"
                      formControlName="ebasketInventoryConsumerSecret"
                      id="ebasketCustomerSecret"
                      matInput
                      [placeholder]="
                    'organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.consumer_secret' |
                    translate"
                    />
                  </mat-form-field>
                </div>
                <div fxFlex="50">
                  <mat-form-field class="mat-block">
                    <input
                      [required]="isRequired('ebasketInventoryAccessToken')"
                      formControlName="ebasketInventoryAccessToken"
                      id="ebasketAccessToken"
                      matInput
                      [placeholder]="
                    'organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.access_token' |
                    translate"
                    />
                  </mat-form-field>
                </div>
              </div>
              <div fxLayout="row wrap" fxLayoutGap="20px grid">
                <div fxFlex="50">
                  <mat-form-field class="mat-block">
                    <input
                      [required]="isRequired('ebasketInventoryTokenSecret')"
                      formControlName="ebasketInventoryTokenSecret"
                      id="ebasketTokenSecret"
                      matInput
                      [placeholder]="
                    'organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.token_secret' |
                    translate"
                    />
                  </mat-form-field>
                </div>
                <div fxFlex="50">
                  <mat-form-field class="mat-block">
                    <input
                      [required]="isRequired('ebasketInventoryAccountId')"
                      formControlName="ebasketInventoryAccountId"
                      id="ebasketAccountId"
                      matInput
                      [placeholder]="
                    'organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.account_id' |
                    translate"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <!-- <mat-error *ngIf="!parentForm.valid || !isEBasketInventoryAddDisabled">
          {{ "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.authentication_details_required" | translate }}
        </mat-error> -->
      </div>
    </div>
    <div fxLayout="row wrap" fxLayoutGap="20px grid">
      <div fxFlex="100">
        <mat-card class="u-margin-bottom-15">
          <mat-card-header>
            <div fxFlex="20" class="u-text-left">
              <mat-card-title>{{ "magento.api_details" | translate }}</mat-card-title>
            </div>
            <div fxFlex="80" class="u-text-right">
              <button
                [disabled]="action=='view' || isEBasketInventoryAddDisabled"
                mat-flat-button
                color="primary"
                (click)="openEbasketInventorySelectApiPopup();"
              >
                {{ 'magento.add' | translate}}
              </button>
            </div>
          </mat-card-header>
          <mat-card-content
            *ngFor="let apiDetails of parentForm.get(authControlKey).get('ebasketInventoryApiDetails')['controls']; let i = index"
            formArrayName="ebasketInventoryApiDetails"
          >
            <div [formGroupName]="i">
              <div fxFlex="80">
                <mat-accordion>
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        {{ apiDetails.value.selectedApi}}
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div fxLayout="row wrap" fxLayoutGap="20px grid">
                      <div fxFlex="50">
                        <mat-form-field class="mat-block">
                          <input
                            id="ebasketURL"
                            [required]="isRequired('url')"
                            formControlName="url"
                            matInput
                            [placeholder]="
                    'magento.url' |
                    translate"
                          />
                        </mat-form-field>
                      </div>
                      <div fxFlex="50">
                        <mat-form-field class="mat-block">
                          <input
                            [required]="isRequired('script')"
                            formControlName="script"
                            id="ebasketScript"
                            matInput
                            [placeholder]="
                    'organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.script' |
                    translate"
                          />
                        </mat-form-field>
                      </div>
                    </div>
                    <div fxLayout="row wrap" fxLayoutGap="20px grid">
                      <div fxFlex="50">
                        <mat-form-field class="mat-block">
                          <input
                            [required]="isRequired('deploy')"
                            formControlName="deploy"
                            id="ebasketDeploy"
                            matInput
                            [placeholder]="
                    'organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.deploy' |
                    translate"
                          />
                        </mat-form-field>
                      </div>
                      <div fxFlex="50">
                        <mat-form-field class="mat-block">
                          <mat-select
                            id="ebasketMethod"
                            formControlName="method"
                            [placeholder]="
                      'magento.select_method' |
                      translate"
                          >
                            <mat-option
                              *ngFor="let methods of method_types"
                              [value]="methods.value"
                            >
                              {{methods.name}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
              <div fxFlex="20" class="u-text-right">
                <button
                  [disabled]="action=='view'"
                  mat-flat-button
                  color="primary"
                  (click)="deleteEbasketInventoryApiDetailContainer(i);"
                >
                  {{ 'magento.delete' | translate}}
                </button>
              </div>
            </div>
          </mat-card-content>

          <div
            *ngFor="let apiDetails of parentForm.get(authControlKey).get('ebasketInventoryApiDetails')['controls']; let i = index"
          >
            <mat-error
              *ngIf="(!apiDetails.value.url || !apiDetails.value.script || !apiDetails.value.deploy || !apiDetails.value.method) && action !== 'view'"
            >
              {{
              "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.api_and_authentication_details_required"
              | translate }}
            </mat-error>
          </div>

          <!-- <mat-error *ngIf="!parentForm.valid">
            {{
            "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.api_and_authentication_details_required"
            | translate }}
          </mat-error> -->
        </mat-card>
      </div>
      <!-- <div *ngFor="let apiDetails of parentForm.get(authControlKey).get('ebasketInventoryApiDetails')['controls']; let i = index"> -->
      <!-- *ngIf="!apiDetails.value.url || !apiDetails.value.script || !apiDetails.value.deploy || !apiDetails.value.method" -->
      <!-- </div> -->
    </div>
  </div>
</div>
